import {
  all, call, fork, put, takeEvery,
} from 'redux-saga/effects';

// action creators
import { doneIndicator, error } from '../../actions/httpActions';

// api
import { remove } from '../../sources/api/client';
import membershipConcernService from '../../sources/api/membershipConcernService';

// constants
import {
  MEMBERSHIP_CONCERN_DELETE,
  MEMBERSHIP_CONCERN_DELETE_INIT,
} from '../../constants/membershipConcernTypes';

// lib
import httpSaga from '../../lib/httpSaga';

// schemas
import { membershipConcernSchema } from '../../schemas/membershipConcern';

export function* membershipConcernDelete(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const { id, chapter } = action.payload || {};

  const options = {
    query: {
      chapter,
    },
  };

  try {
    yield* httpSaga(
      MEMBERSHIP_CONCERN_DELETE,
      call(remove, membershipConcernService, id, options),
      {
        schema: membershipConcernSchema,
      },
    );
  } catch (err) {
    yield put(error(MEMBERSHIP_CONCERN_DELETE, err));
  } finally {
    yield put(doneIndicator(MEMBERSHIP_CONCERN_DELETE));
  }
}

export function* watchMembershipConcernDelete() {
  yield takeEvery(MEMBERSHIP_CONCERN_DELETE_INIT, membershipConcernDelete);
}

export default function* root() {
  yield all([fork(watchMembershipConcernDelete)]);
}
